// @ts-expect-error - imported from .js/.jsx file
import {DoorClosedIcon} from '../../../icon/svg/door-closed-icon';
// @ts-expect-error - imported from .js/.jsx file
import {DoorOpenIcon} from '../../../icon/svg/door-open-icon';
// @ts-expect-error - imported from .js/.jsx file
import {PersonCheckIcon} from '../../../icon/svg/person-check-icon';

export const getThreadBannerAction = (bannerType: string) => {
    switch (bannerType) {
        case 'closed':
            return 'Closed';
        case 'reopened':
            return 'Reopened';
        default:
            return 'Started';
    }
};

export const getThreadBannerIcon = (bannerType: string) => {
    switch (bannerType) {
        case 'closed':
            return DoorClosedIcon;
        case 'reopened':
            return DoorOpenIcon;
        default:
            return null;
    }
};

export const getAssignmentBannerAction = (bannerType: string, assigneeName?: string | null) => {
    switch (bannerType) {
        case 'unassigned':
            return `Unassigned from ${assigneeName || ''}`;
        case 'reassigned':
            return `Re-assigned to ${assigneeName || ''}`;
        case 'assigned':
        default:
            return `Assigned to ${assigneeName || ''}`;
    }
};

export const getAssignmentBannerIcon = (bannerType: string) => {
    switch (bannerType) {
        case 'unassigned':
            return PersonCheckIcon; // TODO
        case 'reassigned':
            return PersonCheckIcon;
        case 'assigned':
        default:
            return PersonCheckIcon;
    }
};
